import { AxiosError } from 'axios';
import { authFetch } from '~/services/fetch';
import { IParamsTable, IUpdateProps } from '../../../interfaces';


export async function getUnitMeasurementById(id: IUpdateProps) {
    const response = await authFetch({
        url: `/unit-measurement/${id}`,
        method: 'GET' 
    });
    return response.data;
}

export async function getUnitMeasurement({
  filters = [],
  limit = 100000,
  orders = [
      {field: 'name', sort: 'asc'}
  ]
}: IParamsTable = {}) {
  const response = await authFetch({
      url: `/unit-measurement/`,
      method: 'POST',
      data: { 
          limit,
          filters,
          orders
      },
      
  });
  return response.data.data;
}
